/* Localidades numeradas x2 (o x3...): las sillas se venden de "factor" en "factor" dentro de la misma mesa o
   fila, por un precio (Evento -> Localidades y asientos -> Boletos por precio). El carrito ya cobra por
   paquete con factor_boletos; aqui solo se valida la seleccion. El backend vuelve a validarlo al comprar. */

export const factorDeLocalidad = (precio) => {
    const f = Math.floor(Number(precio?.factor_boletos || 1))
    return f > 1 && f <= 10 ? f : 1
}

const esCorrelativo = (precio) => String(precio?.typo || precio?.tipo || precio?.tipo_localidad || "").toLowerCase() === "correlativo"

// Mesa o fila de una silla: "A1-s-3" -> "A1", "B-s-12" -> "B"
export const grupoDeSilla = (silla) => String(silla || "").replace(/-s-\d+\s*$/i, "")

// Grupos (mesa / fila) cuya cantidad de sillas elegidas no es multiplo del factor: [{ grupo, elegidas, faltan }]
export const gruposIncompletos = (sillas, factor) => {
    if (!(factor > 1)) return []
    const conteo = new Map()
    for (const s of sillas || []) {
        const g = grupoDeSilla(s.silla)
        conteo.set(g, (conteo.get(g) || 0) + 1)
    }
    return [...conteo].filter(([, n]) => n % factor !== 0)
        .map(([grupo, n]) => ({ grupo: grupo.split("__")[0], elegidas: n, faltan: factor - (n % factor) }))
}

/* Revisa las sillas elegidas de todas las localidades numeradas x2. sillas: las de sillasSlice
   ({ localidad, localidaEspacio, silla, estado }). Devuelve el mensaje a mostrar o "" si todo esta bien. */
export const mensajeParesX2 = (sillas) => {
    const porLocalidad = new Map()
    for (const s of sillas || []) {
        const estado = String(s?.estado || "").toLowerCase()
        if (estado && estado !== "seleccionado" && estado !== "reservado") continue
        const precio = s?.localidaEspacio || {}
        const factor = factorDeLocalidad(precio)
        if (factor <= 1 || esCorrelativo(precio)) continue
        if (!porLocalidad.has(s.localidad)) porLocalidad.set(s.localidad, { factor, sillas: [] })
        porLocalidad.get(s.localidad).sillas.push(s)
    }
    for (const [localidad, { factor, sillas: lista }] of porLocalidad) {
        const incompletos = gruposIncompletos(lista, factor)
        if (incompletos.length) {
            const g = incompletos[0]
            return `"${localidad}" es x${factor}: elige las sillas de ${factor} en ${factor} en la misma mesa o fila. ` +
                `En ${g.grupo} elegiste ${g.elegidas}: elige ${g.faltan} más o quita ${g.elegidas % factor}.`
        }
    }
    return ""
}
